import { getDateField } from '@lender/utils';
import _ from 'lodash';
import { object } from 'yup';

import { EMPTY_GUID } from 'constants/data';

export const getBundleDocumentTypeId = bundle => {
  const documentTypeId = bundle?.documentTypeId;

  return _.isNil(documentTypeId) || documentTypeId === EMPTY_GUID ? null : documentTypeId;
};

export const getUploadFormDeliverySchema = () =>
  object().shape({
    sentDate: getDateField({ isRequired: true }),
    eSignedDate: getDateField({ isRequired: false }),
  });
